/**
 * Guesses the Browser name from the userAgent string
 * @returns {string} Browser name
 */
export default function getBrowser() {
  if (typeof window === 'undefined') return;

  const { userAgent } = navigator;

  if (userAgent.includes('Opera') || userAgent.includes('OPR')) {
    return 'Opera';
  } else if (userAgent.includes('Edg')) {
    return 'Edge';
  } else if (userAgent.includes('Chrome')) {
    return 'Chrome';
  } else if (userAgent.includes('Safari')) {
    return 'Safari';
  } else if (userAgent.includes('Firefox')) {
    return'Firefox';
  } else if ((userAgent.includes('MSIE')) || (!!document.documentMode == true)) {
    return 'IE';
  }

  return 'unknown';
}
